module.exports = __webpack_public_path__ + "static/img/rule-btn.ea7871fb.png";